import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const TiposCliente = () => {
  const [ref, isVisible] = useScrollAnimation();

  const handleCardClick = () => {
    const element = document.querySelector('#consulta-multas');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const tiposCliente = [
    {
      titulo: 'Partners',
      icono: 'bi-people-fill',
      descripcion: 'Servicios especializados para partners',
      color: '#1E3A5F'
    },
    {
      titulo: 'Particulares',
      icono: 'bi-person',
      descripcion: 'Solución rápida y eficiente para particulares',
      color: '#1E3A5F'
    },
    {
      titulo: 'Flotas/Empresas',
      icono: 'bi-building',
      descripcion: 'Gestión integral para flotas y empresas',
      color: '#1E3A5F'
    }
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container" ref={ref}>
        <div className="text-center mb-5">
          <h2 className={`fw-bold mb-3 ${isVisible ? 'animate-fade-in' : ''}`}>
            ¿Qué tipo de cliente sos?
          </h2>
          <p className={`text-muted ${isVisible ? 'animate-fade-in' : ''}`} style={{ animationDelay: '0.1s' }}>
            Elegí tu perfil y consultá tus fotomultas
          </p>
        </div>
        <div className="row g-4">
          {tiposCliente.map((tipo, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div 
                className={`card h-100 shadow-sm border-0 ${isVisible ? 'animate-fade-in' : ''}`}
                style={{ 
                  animationDelay: `${index * 0.1}s`,
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onClick={handleCardClick}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                }}
              >
                <div className="card-body text-center p-4">
                  <div className="mb-3">
                    <i 
                      className={`bi ${tipo.icono}`} 
                      style={{ 
                        fontSize: '3rem', 
                        color: tipo.color 
                      }}
                    ></i>
                  </div>
                  <h4 className="card-title fw-bold mb-3" style={{ color: tipo.color }}>
                    {tipo.titulo}
                  </h4>
                  <p className="card-text text-muted mb-4">
                    {tipo.descripcion}
                  </p>
                  <button 
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCardClick();
                    }}
                  >
                    Consultar Multas
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TiposCliente;

